import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=2fb515e0&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"
import style0 from "./RecordForm.vue?vue&type=style&index=0&id=2fb515e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb515e0",
  null
  
)

export default component.exports